import React from 'react';
import PropTypes from 'prop-types';
import {
  SideMenu,
  SideMenuItem,
  AppBar,
  AppBarLeftSection,
  Footer,
  Icon,
} from '@veneer/core';
// import 'bootstrap-grid/dist/grid.css';
import '@veneer/core/dist/css/veneer.css';
// import '../css/layout.css';
import moment from 'moment';
import { authenticationService } from '../../services/context/AuthService';
import i18n from './../../i18n';
import { history } from '../../services/helpers/history';

const pagesTree = [
  {
    name: 'Home',
    icon: 'dashboard',
    url: '/',
    visible: true,
  },
  {
    name: 'Cost per print',
    icon: 'subscription',
    visible: true,
    children: [
      {
        name: 'Report',
        // icon: 'bar-graph',
        visible: true,
        url: '/cpp/report',
      },
      {
        name: 'Bonus Report',
        visible: true,
        url: '/BonusReport',
      },
      {
        name: 'Add. Claims Report',
        visible: true,
        url: '/',
      },
      {
        name: 'Bonus Table',
        visible: true,
        url: '/cpp/BonusTable',
      },
      {
        name: 'OMP Rate',
        visible: true,
        url: '/',
      },
      {
        name: 'Special Condition',
        visible: true,
        url: '/',
      },
      {
        name: 'Price List - Supplies',
        visible: true,
        url: '/',
      },
      {
        name: 'Recomended Price List by HP',
        visible: true,
        url: '/',
      },
      {
        name: 'Warranty Shipments',
        visible: true,
        url: '/',
      },
    ],
  },
  {
    name: 'Reports',
    icon: 'reports',
    visible: true,
    children: [
      {
        name: 'TPI/Supply Report',
        // icon: 'bar-graph',
        visible: true,
        url: '/',
      },
      {
        name: 'Date Base',
        // icon: 'bar-graph',
        visible: true,
        url: '/',
      },
    ],
  },
  {
    name: 'Compensation',
    icon: 'currency',
    visible: true,
    children: [
      {
        name: 'Balance Report',
        // icon: 'bar-graph',
        visible: true,
        url: '/',
      },
      {
        name: 'Orders',
        // icon: 'bar-graph',
        visible: true,
        url: '/compensation/orders',
      },
      {
        name: 'Channel Redeem',
        // icon: 'bar-graph',
        visible: true,
        url: '/',
      },
    ],
  },
  {
    name: 'Resources',
    icon: 'folder',
    visible: true,
    children: [
      {
        name: 'Resellers Operating Manual',
        // icon: 'bar-graph',
        visible: true,
        url: '/',
      },
      {
        name: 'Supplies Guidelines',
        // icon: 'bar-graph',
        visible: true,
        url: '/',
      },
      {
        name: 'Supplies Performance Policy',
        // icon: 'bar-graph',
        visible: true,
        url: '/',
      },
      {
        name: 'Special Inks',
        // icon: 'bar-graph',
        visible: true,
        url: '/',
      },
      {
        name: 'Treinamentos',
        // icon: 'bar-graph',
        visible: true,
        url: '/',
      },
      {
        name: 'Program de Reciclagem',
        // icon: 'bar-graph',
        visible: true,
        url: '/',
        children: [
          {
            name: 'Recycling Program HP Brazil',
            // icon: 'bar-graph',
            visible: true,
            url: '/',
          },
          {
            name: 'BID Take Back Brazil - video',
            // icon: 'bar-graph',
            visible: true,
            url: '/',
          },
          {
            name: 'BID Take Back Brazil - ppt',
            // icon: 'bar-graph',
            visible: true,
            url: '/',
          },
          {
            name: 'Guide - How to Ship the BID',
            // icon: 'bar-graph',
            visible: true,
            url: '/',
          },
          {
            name: 'Guide - How to Pack the BID',
            // icon: 'bar-graph',
            visible: true,
            url: '/',
          },
          {
            name: 'Request the shipment here',
            // icon: 'bar-graph',
            visible: true,
            url: '/',
          },
        ],
      },
    ],
  },
  {
    name: 'Inventory',
    icon: 'notes',
    visible: true,
    url: '/',
  },
  {
    name: 'Contact Us',
    icon: 'email',
    visible: true,
    url: '/',
  },
  {
    name: 'Logout',
    icon: 'inactive',
    visible: true,
    url: '/',
  },
];

const Foundation = ({ children, location }) => {
  //console.log(children);
  //console.log(children.props.location);
  let headerTitle = '';
  const processArray = (items, p) =>
    items.map((item, index) => p(item, item, index + 1));

  const processObject = (item, p) => {
    const slug = item.name.toLowerCase().replace(new RegExp(' ', 'g'), '_');
    const lastPathName =
      children.props.location.pathname.split('/').slice(-1)[0] ||
      'introduction';
    const selected = slug === lastPathName;
    let url = item.url;
    if (url === undefined) {
      url = `#/${slug}`;
    }

    if (selected) {
      headerTitle = item.name;
    }

    // Check if item is submenu
    if (item.children !== undefined) {
      url = null;
    }

    return (
      <SideMenuItem
        label={item.name}
        key={item.name}
        url={url}
        selected={selected}
        icon={item.icon}
        urlTarget={item.target}
      >
        {p(item.children)}
      </SideMenuItem>
    );
  };

  const processNode = (value) => {
    if (value instanceof Array) {
      return processArray(value, processNode);
    }
    if (value instanceof Object) {
      return processObject(value, processNode);
    }
    return null;
  };
  const sideMenuItems = processNode(pagesTree);

  return (
    <div>
      <SideMenu logoImagePath={''} logoUrl="#/" logoTitle="Veneer" theme="hp">
        {sideMenuItems}
      </SideMenu>
      <AppBar className="appbar__bottom-line" menuEnabled>
        <AppBarLeftSection>
          <h1 className="header-title" slot="left">
            {headerTitle}
          </h1>
        </AppBarLeftSection>
      </AppBar>
      <main className="content vn-background-color--background">
        <section className="content__wrapper margin-bottom container">
          {children}
        </section>
      </main>
      <Footer
        mainContent={{
          leftArea: (
            <div
              style={{
                alignItems: 'center',
                display: 'flex',
                fontFamily: "'HP Simplified', Arial, sans-serif",
                fontSize: '20px',
              }}
            >
              {/* <Icon
                multicolor
                name="hp"
                size={24}
                css={{ marginRight: '10px' }}
              /> */}
              <span>Application</span>
            </div>
          ),

          rightArea: <span>© Copyright. All rights reserved.</span>,
        }}
      />
    </div>
  );
};

Foundation.propTypes = {
  children: PropTypes.node,
  location: PropTypes.shape({
    pathname: PropTypes.string,
  }).isRequired,
};

Foundation.defaultProps = {
  children: null,
};

export default Foundation;
